import type { LeaderboardRow } from '@chessbut/shared';
import { formatFull } from '../lib/format.ts';
import { Link } from '../lib/router.tsx';

function Row({ r, meId }: { r: LeaderboardRow; meId: string | null }) {
  const isMe = r.playerId === meId;
  const name = r.username ? <Link to={`/u/${r.username}`}>{r.name}</Link> : r.name;
  return (
    <tr className={`${r.rank <= 3 ? 'top' : ''} ${isMe ? 'is-me' : ''}`}>
      <td className="c-rank">{r.rank}</td>
      <td className="c-name">
        {name}
        {isMe && <span className="you-tag">you</span>}
      </td>
      <td className="c-num">{r.games}</td>
      <td className="c-value">
        {formatFull(r.value)}
        {r.provisional ? <span className="q">?</span> : null}
      </td>
    </tr>
  );
}

/** A crosstable: rank, player, games, and the value (points, moves or rating) in its own column. */
export function LeaderboardTable({
  rows,
  me,
  unit,
  meId,
  empty,
}: {
  rows: LeaderboardRow[];
  me: LeaderboardRow | null;
  unit: string;
  meId: string | null;
  empty: string;
}) {
  if (!rows.length && !me) return <p className="empty">{empty}</p>;
  const meInRows = me && rows.some((r) => r.playerId === me.playerId);
  const last = rows.at(-1)?.rank ?? 0;
  const valueLabel = unit ? unit[0].toUpperCase() + unit.slice(1) : 'Rating';
  return (
    <table className="crosstable leaderboard">
      <thead>
        <tr>
          <th className="c-rank" scope="col">
            #
          </th>
          <th scope="col">Player</th>
          <th className="c-num" scope="col">
            Games
          </th>
          <th className="c-value" scope="col">
            {valueLabel}
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <Row key={r.playerId} r={r} meId={meId} />
        ))}
        {me && !meInRows && me.rank > last + 1 && (
          <tr className="gap" aria-hidden>
            <td colSpan={4}>⋮</td>
          </tr>
        )}
        {me && !meInRows && <Row r={me} meId={meId} />}
      </tbody>
    </table>
  );
}
